import React from 'react';
import styled from 'styled-components';

// Privacy Policy & Terms of Use — accessible from Help and Support / Control Panel

function PrivacyTerms() {
    return (
        <Container>
            <Tabs>
                <Tab className="active">Privacy Policy</Tab>
                <Tab>Terms of Use</Tab>
            </Tabs>
            <Content>
                <Section>
                    <Title>Privacy Policy</Title>
                    <Updated>Last updated: February 2026</Updated>

                    <Heading>Who We Are</Heading>
                    <p>
                        Dead Simple Computing Ltd ("Dead Simple Computing", "we", "us", "our") is an IT services company registered in England & Wales. Our registered address is in Reading, Berkshire.
                    </p>
                    <p>
                        Dead Simple Accounting is a trading name of the same company, providing bookkeeping and tax return services.
                    </p>

                    <Heading>What This Website Is</Heading>
                    <p>
                        <strong>deadsimple.uk</strong> is an interactive marketing website that simulates a Windows XP desktop environment. It is a novelty experience designed to showcase our IT and accounting services in a fun, nostalgic format. No real computing takes place on your machine beyond running this website.
                    </p>

                    <Heading>What Data We Collect</Heading>
                    <p>
                        <strong>We do not collect any personal data through this website.</strong>
                    </p>
                    <ul>
                        <li>No cookies are set for tracking or analytics purposes.</li>
                        <li>No forms collect personal information.</li>
                        <li>No user accounts are required or created.</li>
                        <li>No data is transmitted to any server — everything runs locally in your browser.</li>
                    </ul>

                    <Heading>Third-Party Services</Heading>
                    <p>
                        This website may embed content from third-party sources (e.g., embedded game iframes). These third parties may have their own privacy policies. We do not control how they process data.
                    </p>

                    <Heading>Contact Us</Heading>
                    <p>
                        If you have any questions about this privacy policy or our services:
                    </p>
                    <ul>
                        <li>📞 <strong>Telephone:</strong> 0118 359 2220</li>
                        <li>🌐 <strong>Website:</strong> deadsimplecomputing.co.uk</li>
                        <li>🌐 <strong>Accounting:</strong> deadsimpleaccounting.co.uk</li>
                    </ul>
                </Section>

                <Separator />

                <Section>
                    <Title>Terms of Use</Title>
                    <Updated>Last updated: February 2026</Updated>

                    <Heading>1. Acceptance of Terms</Heading>
                    <p>
                        By accessing and using deadsimple.uk, you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, please close the website.
                    </p>

                    <Heading>2. Nature of the Website</Heading>
                    <p>
                        This website is an interactive marketing demonstration. It simulates a Windows XP desktop environment for entertainment and promotional purposes. It is not a real operating system and does not perform any actual computing tasks on your device.
                    </p>
                    <p>
                        The simulated "virus alerts", "security warnings", and other notifications are fictional and are included for comedic effect only. They do not reflect the actual state of your computer.
                    </p>

                    <Heading>3. Intellectual Property</Heading>
                    <p>
                        The Windows XP interface, icons, and branding are trademarks of Microsoft Corporation. This website is a parody/tribute and is not affiliated with, endorsed by, or connected to Microsoft.
                    </p>
                    <p>
                        Dead Simple Computing, Dead Simple Accounting, and the Dead Simple brand are © Dead Simple Computing Ltd.
                    </p>

                    <Heading>4. Disclaimer</Heading>
                    <p>
                        This website is provided "as is" without warranty of any kind. We are not responsible for any consequences of using this website, including but not limited to:
                    </p>
                    <ul>
                        <li>Nostalgia-induced emotional responses</li>
                        <li>Uncontrollable urges to dig out your old XP machine</li>
                        <li>Time lost playing Minesweeper and Solitaire</li>
                        <li>Sudden appreciation for modern IT security practices</li>
                    </ul>

                    <Heading>5. Limitation of Liability</Heading>
                    <p>
                        Dead Simple Computing Ltd shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of this website. In particular, we accept no responsibility if you actually try to download BonziBuddy after being reminded of its existence.
                    </p>

                    <Heading>6. Contact</Heading>
                    <p>
                        For any questions regarding these terms, please contact us at:
                    </p>
                    <ul>
                        <li>📞 0118 359 2220</li>
                        <li>🌐 deadsimplecomputing.co.uk</li>
                    </ul>
                </Section>
            </Content>
        </Container>
    );
}

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f0f0f0;
    font-family: Tahoma, 'Segoe UI', sans-serif;
    font-size: 11px;
`;

const Tabs = styled.div`
    display: flex;
    background: #ece9d8;
    padding: 4px 8px 0;
    border-bottom: 1px solid #aca899;
`;

const Tab = styled.div`
    padding: 4px 16px;
    background: #f0f0f0;
    border: 1px solid #aca899;
    border-bottom: none;
    border-radius: 3px 3px 0 0;
    margin-right: 2px;
    cursor: pointer;
    color: #333;
    &.active {
        background: #fff;
        border-bottom: 1px solid #fff;
        margin-bottom: -1px;
        font-weight: bold;
    }
    &:hover:not(.active) {
        background: #e8e8e8;
    }
`;

const Content = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    background: #fff;
    line-height: 1.6;
    color: #333;
`;

const Section = styled.div`
    margin-bottom: 16px;
`;

const Title = styled.h2`
    font-size: 16px;
    font-weight: bold;
    color: #003399;
    margin: 0 0 4px;
    font-family: Tahoma, sans-serif;
`;

const Updated = styled.div`
    font-size: 10px;
    color: #888;
    margin-bottom: 12px;
    font-style: italic;
`;

const Heading = styled.h3`
    font-size: 12px;
    font-weight: bold;
    color: #003399;
    margin: 14px 0 4px;
    font-family: Tahoma, sans-serif;
`;

const Separator = styled.hr`
    border: none;
    border-top: 1px solid #ccc;
    margin: 20px 0;
`;

export default PrivacyTerms;
